import React from 'react'
import { View, ViewStyle } from 'react-native'
import { Text } from '../text'
import { typography } from '../../theme'

interface LabelProps {
  labelText?: string
  labelTx?: string
  txOptions?: any
  style?: ViewStyle
  labelColor: { background: string; text: string }
  icon?: any
  /**
   * Label text variant
   * @default body2Emphasized
   **/
  textVariant?: keyof typeof typography
}
export const Label = (props: LabelProps) => {
  const { labelText, textVariant, txOptions, icon, labelTx, style, labelColor } = props
  return (
    <View style={{ ...ROOT, backgroundColor: labelColor.background, ...style }}>
      <View style={{ marginRight: icon ? 6 : 0 }}>{icon}</View>
      <Text
        style={{ color: labelColor.text }}
        variant={textVariant}
        text={labelText}
        tx={labelTx}
        txOptions={txOptions}
      />
    </View>
  )
}

const ROOT: ViewStyle = {
  minHeight: 22,
  paddingHorizontal: 8,
  paddingVertical: 4,
  borderRadius: 8,
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
}
